import { useState, useMemo } from 'react';
import { documentLogService } from '../services/document-log.service';

export function useDocumentLog() {
  const [saving, setSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);

  const fetchDocumentLogs = async (dto: any) => {
    return documentLogService.getAllDocumentLogs(dto);
  };

  const createDocumentLog = async (data: Record<string, any>) => {
    setSaving(true);
    setSaveSuccess(false);
    setSaveError(null);
    try {
      await documentLogService.createDocumentLog(data);
      setSaveSuccess(true);
    } catch (e: any) {
      setSaveError(e.message || 'Failed to create document log');
      throw e;
    } finally {
      setSaving(false);
    }
  };

  const updateDocumentLog = async (id: string, data: Record<string, any>) => {
    return documentLogService.updateDocumentLog(id, data);
  };

  const deleteDocumentLog = async (id: string) => {
    return documentLogService.deleteDocumentLog(id);
  };

  const getDocumentLogById = async (id: string) => {
    return documentLogService.getDocumentLogById(id);
  };

  return {
    fetchDocumentLogs,
    createDocumentLog,
    updateDocumentLog,
    deleteDocumentLog,
    getDocumentLogById,
    saving,
    saveSuccess,
    saveError,
    setSaveSuccess,
    setSaveError,
  };
}
